import React from 'react';
import Navbar from '../../components/navbar/Navbar';
import { Box } from '@mui/material';
import EventPage from '../../components/event_page/EventPage';
import Footer from '../../components/Footer/Footer';

const EventPageWithNav = () => {
	return (
		<Box>
			<Navbar />
			<EventPage />
			<Footer />
		</Box>
	);
};

export default EventPageWithNav;
